var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule, JsonpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';
/**
 * COMMON
 */
import { CovalentCommonModule } from './common/common.module';
export * from './common/common.module';
/**
 * CHIPS
 */
import { CovalentChipsModule } from './chips/chips.module';
export * from './chips/chips.module';
/**
 * DATA TABLE
 */
import { CovalentDataTableModule } from './data-table/data-table.module';
export * from './data-table/data-table.module';
/**
 * DIALOGS
 */
import { CovalentDialogsModule } from './dialogs/dialogs.module';
export * from './dialogs/dialogs.module';
/**
 * EXPANSION PANEL
 */
import { CovalentExpansionPanelModule } from './expansion-panel/expansion-panel.module';
export * from './expansion-panel/expansion-panel.module';
/**
 * FILE
 */
import { CovalentFileModule } from './file/file.module';
export * from './file/file.module';
/**
 * JSON FORMATTER
 */
import { CovalentJsonFormatterModule } from './json-formatter/json-formatter.module';
export * from './json-formatter/json-formatter.module';
/**
 * LAYOUT
 */
import { CovalentLayoutModule } from './layout/layout.module';
export * from './layout/layout.module';
/**
 * LOADING
 */
import { CovalentLoadingModule } from './loading/loading.module';
export * from './loading/loading.module';
/**
 * MEDIA
 */
import { CovalentMediaModule } from './media/media.module';
export * from './media/media.module';
/**
 * MENU
 */
import { CovalentMenuModule } from './menu/menu.module';
export * from './menu/menu.module';
/**
 * NOTIFICATIONS
 */
import { CovalentNotificationsModule } from './notifications/notifications.module';
export * from './notifications/notifications.module';
/**
 * PAGING
 */
import { CovalentPagingModule } from './paging/paging.module';
export * from './paging/paging.module';
/**
 * SEARCH
 */
import { CovalentSearchModule } from './search/search.module';
export * from './search/search.module';
/**
 * STEPS
 */
import { CovalentStepsModule } from './steps/steps.module';
export * from './steps/steps.module';
var CovalentCoreModule = CovalentCoreModule_1 = (function () {
    function CovalentCoreModule() {
    }
    CovalentCoreModule.forRoot = function () {
        return {
            ngModule: CovalentCoreModule_1,
            providers: [],
        };
    };
    return CovalentCoreModule;
}());
CovalentCoreModule = CovalentCoreModule_1 = __decorate([
    NgModule({
        imports: [
            HttpModule,
            JsonpModule,
            FormsModule,
            CommonModule,
            MaterialModule.forRoot(),
            FlexLayoutModule,
            CovalentCommonModule.forRoot(),
            CovalentChipsModule.forRoot(),
            CovalentDataTableModule.forRoot(),
            CovalentDialogsModule.forRoot(),
            CovalentExpansionPanelModule.forRoot(),
            CovalentFileModule.forRoot(),
            CovalentJsonFormatterModule.forRoot(),
            CovalentLayoutModule.forRoot(),
            CovalentLoadingModule.forRoot(),
            CovalentMediaModule.forRoot(),
            CovalentMenuModule.forRoot(),
            CovalentNotificationsModule.forRoot(),
            CovalentPagingModule.forRoot(),
            CovalentSearchModule.forRoot(),
            CovalentStepsModule.forRoot(),
        ],
        exports: [
            HttpModule,
            JsonpModule,
            FormsModule,
            CommonModule,
            MaterialModule,
            FlexLayoutModule,
            CovalentCommonModule,
            CovalentChipsModule,
            CovalentDataTableModule,
            CovalentDialogsModule,
            CovalentExpansionPanelModule,
            CovalentFileModule,
            CovalentJsonFormatterModule,
            CovalentLayoutModule,
            CovalentLoadingModule,
            CovalentMediaModule,
            CovalentMenuModule,
            CovalentNotificationsModule,
            CovalentPagingModule,
            CovalentSearchModule,
            CovalentStepsModule,
        ],
    })
], CovalentCoreModule);
export { CovalentCoreModule };
var CovalentCoreModule_1;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@covalent/core/index.js
// module id = 42
// module chunks = 3